export default `
	guid
	active
	kind
`;
